<template>
    <nav id="menu" class="slideout-menu menu" v-touch:swipe="handleSwipe">
        <i class="fas fa-times close-button" @click="toggleMenu"></i>
        <perfect-scrollbar>
            <p class="menu-label">
                {{ $t('menu.map_display') }}
            </p>
            <ul class="menu-list">
                <li>{{ $t('menu.my_location') }}
                    <b-switch v-model="showMe"></b-switch>
                </li>
                <li>{{ $t('menu.only_selected_device') }}
                    <b-switch v-model="showIsolated"></b-switch>
                </li>
            </ul>

            <p class="menu-label">
                {{ $t('menu.map_provider') }}
            </p>
            <ul class="menu-list">
                <li
                    :key="tile.name"
                    :class="{'active': $store.getters['map/selectedProvider'] === t}"
                    v-for="(tile, t) in $store.getters['map/tileProviders']"
                    @click="$store.commit('map/tileProviders', t)">
                    {{ tile.name }}
                </li>
            </ul>

            <br/>

            <div>
                <p class="menu-label">
                    {{ $t('menu.language') }}
                </p>
                <b-field style="padding: 15px;">
                    <b-select placeholder="Language" expanded v-model="selectedLanguage">
                        <option
                            v-for="language in languages"
                            :value="language.key"
                            :key="language.key">
                            {{ language.name }}
                        </option>
                    </b-select>
                </b-field>
            </div>
            <br/>

            <p class="menu-label">
                {{ $t('menu.user') }}
            </p>
            <ul class="menu-list">
                <li class="static">{{ $store.state.user.username }}</li>
            </ul>

            <ul class="menu-list" style="position: absolute; bottom: 0; width: 100%;">
                <li class="is-danger" @click="logout()">{{ $t('menu.logout') }}</li>
            </ul>
        </perfect-scrollbar>
    </nav>
</template>

<script>

export default {
    name: 'Menu',
    methods: {
        logout() {
            if (!!window.cordova) {
                WonderPush.clearAllData();
            }
            this.$store.dispatch('logout');
        },
        toggleMenu() {
            this.$store.commit('menuOpen', false);
        },
        handleSwipe(direction) {
            if (direction === 'left') {
                this.toggleMenu();
            }
        }
    },
    computed: {
        languages() {
            return [
                { 'key': 'en', 'name': this.$t('languages.en') },
                { 'key': 'si', 'name': this.$t('languages.si') },
                { 'key': 'hr', 'name': this.$t('languages.hr') }
            ];
        },
        showLabels: {
            get() {
                return this.$store.getters['map/showLabels'];
            },
            set(value) {
                this.$store.commit('map/showLabels', value);
            }
        },
        selectedLanguage: {
            get() {
                return this.$store.getters['language'];
            },
            set(value) {
                this.$store.dispatch('language', value);
            }
        },
        showMe: {
            get() {
                return this.$store.getters['map/showMe'];
            },
            set(value) {
                this.$store.commit('map/showMe', value);
            }
        },
        showIsolated: {
            get() {
                return this.$store.getters['map/showIsolated'];
            },
            set(value) {
                this.$store.commit('map/showIsolated', value);
            }
        }
    }
};
</script>

<style lang="scss">
#menu {
    overflow: auto;
    height: 100%;

    .ps {
        height: 100%;
    }
}

.slideout-menu {
    position: fixed;
    top: 0;
    bottom: 0;
    max-width: 90%;
    width: 370px;
    height: 100vh;
    min-height: 100vh;
    max-height: 100vh;
    z-index: 1600;
    padding: 3em 0 1em;
    display: block;
    overflow: hidden;
    transform: translateX(-370px);
    -webkit-transform: translateX(-370px);
    transition: transform 0.18s linear;
    font-size: 1.2em;
    background-color: $panel-black-darker;
    color: white;
    will-change: transform;

    ul li, p {
        padding-left: 1em;
    }

    ul {
        list-style: none;
        margin: 0;
        padding: 0;

        li:not(.static) {
            padding: 10px 20px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;

            &:hover {
                background-color: lighten(#303a3a, 10);
            }
        }

        li.static {
            color: #8c9b9d;
        }

        li.active {
            color: $primary;
        }
    }

    .menu-label {
        color: #cfcfcf;
    }

    .close-button {
        top: 0.75em;
        right: 0.75em;
    }
}

.slideout-panel {
    position: relative;
    z-index: 1;
    will-change: transform;
    background-color: #FFF; /* A background-color is required */
    min-height: 100vh;
}

.slideout-open,
.slideout-open body,
.slideout-open .slideout-panel {
    overflow: hidden;
}

.slideout-open {
    transform: translateX(0);
    -webkit-transform: translateX(0);
}
</style>
